// extracted by mini-css-extract-plugin
export default {"slider":"DEQUn","selector":"H11Gm"};